module.exports = __webpack_public_path__ + "static/media/waterOff.a26b8dc6.svg";